export default function validatePhone(phone) {
  phone = phone.replace(/[^\d]+/g, '');
  if (phone.length < 10 || phone.length > 11) return false;
  return true;
}
